import { AxiosInstance } from 'axios'

import {
  CreateEmployeesArmiesRequest,
  UploadEmployeeArmyFileRequest,
} from '@modules/employees/types/EmployeesArmies/requests'
import { EmployeePerson } from '@modules/employees/types/EmployeesPersons/employeesPersons'

export class EmployeesArmiesService {
  private instance: AxiosInstance

  constructor(instance: AxiosInstance) {
    this.instance = instance
  }

  async create(data: CreateEmployeesArmiesRequest): Promise<EmployeePerson> {
    const { employeeId, ...body } = data

    const response = await this.instance.post(`/companies/employees/${employeeId}/armies`, body)

    return response.data
  }

  async uploadFile({ employeeId, file }: UploadEmployeeArmyFileRequest): Promise<EmployeePerson> {
    const formData = new FormData()
    formData.append('file', file)

    const response = await this.instance.post(`/companies/employees/${employeeId}/armies/file`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })

    return response.data
  }
}

export const employeesArmiesService = (instance: AxiosInstance) => new EmployeesArmiesService(instance)
